// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"CategoryNav-module--sidebar--3YUpe","active":"CategoryNav-module--active--1zR1Y"};